const base = '/oa/workbench/content/admin/media/chunks'
const cancelled = () => Object.assign(new Error('已取消上传'), { cancelled: true })
const check = signal => { if (signal && signal.aborted) throw cancelled() }
const pause = (ms, signal) => new Promise((resolve, reject) => {
  check(signal)
  const done = () => { clearTimeout(timer); if (signal) signal.removeEventListener('abort', abort) }
  const abort = () => { done(); reject(cancelled()) }
  const timer = setTimeout(() => { done(); resolve() }, ms)
  if (signal) signal.addEventListener('abort', abort, { once: true })
})

export function chunkBase64(blob, signal) {
  return new Promise((resolve, reject) => {
    check(signal)
    const reader = new FileReader()
    const cleanup = () => { if (signal) signal.removeEventListener('abort', abort) }
    const abort = () => { reader.abort(); cleanup(); reject(cancelled()) }
    reader.onload = () => { cleanup(); resolve(String(reader.result).split(',')[1]) }
    reader.onerror = () => { cleanup(); reject(new Error('读取文件失败，请重试')) }
    reader.onabort = () => { cleanup(); reject(cancelled()) }
    if (signal) signal.addEventListener('abort', abort, { once: true })
    reader.readAsDataURL(blob)
  })
}

export async function uploadWorkbenchChunks(http, file, durationSeconds, onProgress, signal) {
  let session
  async function post(path, data, retry = false, progress) {
    for (let attempt = 0; ; attempt++) {
      check(signal)
      try {
        const response = await http.post(base + path, data, { timeout: path.endsWith('/complete') ? 1200000 : 120000, signal, onUploadProgress: progress, workbenchUpload: true, headers: { isLoading: false } })
        check(signal)
        if (!response || response.code !== 0) throw Object.assign(new Error((response && response.message) || '上传失败，请重试'), { definitive: true })
        return response.data
      } catch (error) {
        check(signal)
        const status = error.response && error.response.status
        if (!retry || error.definitive || (status && status < 500 && status !== 408 && status !== 429) || attempt >= 2) throw error
        await pause(500 * (attempt + 1), signal)
      }
    }
  }
  try {
    session = await post('/init', { fileName: file.name, fileSize: file.size, durationSeconds })
    if (!session || !/^[a-f0-9-]{36}$/.test(session.id) || !Number.isInteger(session.partSize) || session.partSize < 1 || session.partSize > 8 * 1048576 || session.partCount !== Math.ceil(file.size / session.partSize)) throw new Error('上传分片参数无效，请重试')
    for (let index = 0; index < session.partCount; index++) {
      check(signal)
      const start = index * session.partSize, part = file.slice(start, Math.min(file.size, start + session.partSize))
      const data = await chunkBase64(part, signal)
      await post('/' + session.id + '/parts/' + index, { data }, true, event => {
        if (event.total) onProgress(Math.min(98, Math.floor((start + part.size * event.loaded / event.total) * 98 / file.size)))
      })
      onProgress(Math.min(98, Math.floor(Math.min(file.size, start + part.size) * 98 / file.size)))
    }
    const media = await post('/' + session.id + '/complete', {}, true)
    if (!media || !media.url) throw new Error('上传未返回文件地址，请重试')
    onProgress(100)
    return media
  } catch (error) {
    if (session && /^[a-f0-9-]{36}$/.test(session.id)) {
      // 取消本身失败不能阻塞原来的错误；服务端仍会清理过期分片。
      Promise.resolve().then(() => http.post(base + '/' + session.id + '/cancel', {}, { timeout: 15000, workbenchUpload: true, headers: { isLoading: false } })).catch(() => {})
    }
    if (signal && signal.aborted) throw cancelled()
    throw error
  }
}
